import apiZervant from '../../../../utils/apiZervant'
import { PaymentRemindersSettings } from './types/paymentReminders/paymentRemindersSettings'

export interface GetAutomaticPaymentRemindersSettingsResponseData {
  data: PaymentRemindersSettings
}

export const getAutomaticPaymentRemindersSettings = (): Promise<GetAutomaticPaymentRemindersSettingsResponseData> => {
  return apiZervant.invoiceDelivery.get('/reminders/v1/reminder/settings')
}

type UpdateAutomaticPaymentRemindersSettingsResponse = PaymentRemindersSettings

export const updateAutomaticPaymentRemindersSettings = async (payload: PaymentRemindersSettings) => {
  return apiZervant.invoiceDelivery.put<UpdateAutomaticPaymentRemindersSettingsResponse>(
    `/reminders/v1/reminder/settings`,
    payload,
  )
}
